import CurrencyNumber from "app/components/CurrencyNumber/CurrencyNumber";
import { IconClose } from "app/components/Icon/Icon";
import {
  BetBuilderEventsType,
  BetBuilderEventType,
} from "app/types/betBuilderType";
import React from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import "../../../BetSlipLists/components/BetSlipList/components/BetSlip/components/BetSlipCompleted/BetSlipCompleted.scss";
import "./BetBuilderCompletedMessage.scss";

type Props = {
  reportList: any;
  clearMultiples: Function;
  betBuilderEvent: BetBuilderEventType;
  betBuilderEvents: BetBuilderEventsType;
  removeBetBuilderBet: Function;
};

const BetBuilderCompletedMessage: React.FC<Props> = ({
  betBuilderEvent,
  removeBetBuilderBet,
}) => {
  const onDelete = (ev: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (ev != null) {
      ev.preventDefault();
    }
    // remove bet builder bet from bet slip list
    removeBetBuilderBet(betBuilderEvent.eventId);
    // disabling feature as not used in flow chart https://ns90ltd.atlassian.net/wiki/spaces/PMO/pages/4774101016/Bet+Builder+Feature+Flowchart
    // disabling remove corresponding single bets from bet slip panel
    // MultiplesHelper.removeCorrespondingSingleBets();
    // disabling clear multiples
    // clearMultiples();
  };

  return (
    <div className="bet-slip-completed bet-builder-bet-slip-completed">
      <div className="bet-slip-completed__header">
        <div className="bet-slip-completed__header__text">
          <FormattedMessage tagName="span" id="bets-betaccepted" />
        </div>
        <div className="bet-slip-completed__header__close" onClick={onDelete}>
          <IconClose />
        </div>
      </div>
      <div>
        <FormattedMessage tagName="span" id="bet-betslip-bet-builder" /> - (
        {betBuilderEvent?.betBuilderItems?.length === 1 && (
          <FormattedMessage tagName="span" id="bet-builder-selection" />
        )}
        {betBuilderEvent?.betBuilderItems?.length > 1 && (
          <FormattedMessage
            tagName="span"
            id="bet-builder-selections"
            values={{
              numberOfSelections: betBuilderEvent.betBuilderItems.length,
            }}
            defaultMessage={""}
          />
        )}
        )
        <br />
        <FormattedMessage tagName="span" id="prices-odds" />:{" "}
        <span data-qa="confirmed_bet_slip_odds">
          {betBuilderEvent.calculatedOdds}
        </span>
        <br />
        <CurrencyNumber value={betBuilderEvent.stake} />{" "}
        <FormattedMessage tagName="span" id="bets-of" />{" "}
        <CurrencyNumber value={betBuilderEvent.requestedStake} />{" "}
        <FormattedMessage tagName="span" id="bets-stake-accepted" />
        <br />
        <FormattedMessage tagName="span" id="bets-return" />{" "}
        <CurrencyNumber value={betBuilderEvent.profit} />
        <br />
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  betBuilderEvents: state.betBuilderModel.betBuilderEvents,
});

const mapDispatchToProps = (dispatch: any) => {
  return {
    clearMultiples: () => {
      dispatch.multiplesBetSlipListModel.clearMultiples();
    },
    removeBetBuilderBet: (eventId: number) => {
      dispatch.betBuilderModel.removeBet({ eventId });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BetBuilderCompletedMessage) as any;
